import { render, staticRenderFns } from "./dialogStatisics.vue?vue&type=template&id=5874efa2&scoped=true"
import script from "./dialogStatisics.vue?vue&type=script&lang=js"
export * from "./dialogStatisics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874efa2",
  null
  
)

export default component.exports